import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  moreLink?: string;
  moreText?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  moreLink,
  moreText = "查看更多",
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
      <div>
        {eyebrow && (
          <p className="mb-1 font-label text-xs font-medium uppercase tracking-widest text-accent-600">
            {eyebrow}
          </p>
        )}
        <h2 className="text-xl font-bold text-foreground-950 md:text-2xl">{title}</h2>
        {description && (
          <p className="mt-1.5 max-w-2xl text-sm text-foreground-600">{description}</p>
        )}
      </div>
      {moreLink && (
        <Link
          to={moreLink}
          className="group inline-flex cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-800"
        >
          {moreText}
          <i className="ri-arrow-right-line text-base transition-transform group-hover:translate-x-0.5"></i>
        </Link>
      )}
    </div>
  );
}